<div class="custom-paginator-container">
    <!-- Custom Pagination UI -->
    <div class="p__custom-paginator">
        <div class="txt__custom-record">
            {{'PAGINATION.HIENTHI'|translate}} {{ getStartIndex() }} {{'PAGINATION.DEN'|translate}} {{ getEndIndex() }} {{'PAGINATION.TRONG'|translate}} {{ pageLength }} {{'PAGINATION.BANGHI'|translate}}
        </div>

        <button (click)="firstPage()" [disabled]="pageIndex === 0">«</button>
        <button (click)="prevPage()" [disabled]="pageIndex === 0">‹</button>

        <span *ngFor="let page of getPageNumbers()" (click)="goToPage(page)"
        [class.active]="pageIndex + 1 === page"> 
        {{ page }}
        </span>

        <button (click)="nextPage()" [disabled]="pageIndex >= getTotalPages() - 1">›</button>
        <button (click)="lastPage()" [disabled]="pageIndex >= getTotalPages() - 1">»</button>
    </div>

    <!-- Dropdown chọn số bản ghi trên mỗi trang -->
    <select class="selectbasic" [(ngModel)]="pageSize" (change)="onPageSizeChange($event)">
        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
    </select>
</div>